<h1 mat-dialog-title>Change shape dimensions</h1>

<mat-dialog-content>
  <div>
    <form class="rescale-form" #dimensionsForm="ngForm">
      <h3-cuboid-dimensions class="cuboid-img"></h3-cuboid-dimensions>

      <section class="dimensions">
        <ng-template ngFor let-i="index" let-field [ngForOf]="fields">
          <mat-form-field appearance="outline">
            <mat-label>
              <span class="dot" [style.backgroundColor]="field.dotColor"></span>
              {{ field.label | titlecase }}</mat-label
            >
            <input
              matInput
              [placeholder]="field.label | titlecase"
              [name]="field.label"
              type="number"
              step="0.01"
              min="0.01"
              [(ngModel)]="data[field.label]"
            />
          </mat-form-field>
        </ng-template>
      </section>

      <section class="options-section">
        <h3-toggle-button-group
          class="toggle"
          [size]="'sm'"
          [buttons]="rescaleMethodButtons"
          [fillArea]="true"
          [(ngModel)]="rescaleMethod"
          name="rescaleMethod"
        ></h3-toggle-button-group>
      </section>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [mat-dialog-close]="null" color="primary">
    Cancel
  </button>
  <button
    mat-button
    type="button"
    [disabled]="!dimensionsForm.form.valid"
    (click)="rescaleAndClose()"
    color="primary"
  >
    Apply
  </button>
</mat-dialog-actions>
